<template lang="jade">
div.Check(v-bind:class="{'Check--error': error}")
  label.Check__label(v-if="fdata.label") {{{ fdata.label }}}
  label.Check__control(":for"="fdata.field")
    input.Check__field(":id"="fdata.field"
                        type="checkbox"
                        ":disabled"="!fdata.editable"
                        v-model="formInput"
                        @change="validate")
    div.Check__indicator
  div.Check__label(v-if="fdata.suffix"
                      class="Check__append") {{{ fdata.suffix }}}
</template>

<script>
  import inputs from '../_shared/traits'

  export default {
    mixins: [inputs],
    data () {
      return {
        checked: this.fdata.value === '' || this.fdata.value === true ? 'true' : this.fdata.value,
        unchecked: 'false'
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce (val) {
          if (val.editable === false) {
            val.field = false
          }
          return val
        }
      }
    },
    ready () {
      // this.formInput = this.fdata.value
      this.validate()
    }
  }
</script>



// WEBPACK FOOTER //
// checkbox.vue?cdd90868